import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'ns-fund-by-check',
  template: require('./fund-by-check.component.html')
})

export class FundByCheckComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);

    this.stepNum = '5';

    this.funtReqURL = this.flowManager.isIra
      ? `${this.flowManager.config.investDocsRoot}invest-ira-contribution`
      : `${this.flowManager.config.investDocsRoot}deposit-slip`;
    this.nextBtnText = 'Next';
    this.flowManager.fundingMethod = 'check';
  }

  ngOnInit() {
    this.authenticated = this.flowManager.isAuthed;
    this.isStreamline = this.appActions.getData('Streamline');
    if (this.authenticated) {
      this.nextBtnText = 'Go to Accounts';
    }


    this.form = {
      stepTitle: 'Fund Your Account'
    };
  }

  btnClick(e) {
    if (e === 'next') {
      if (this.authenticated) {
        this.loadingNext = true;
        this.flowManager.ssoToAlly();
      } else {
        this.router.navigate(['/credentials']);
      }
    } else if (e === 'back') {
      if (this.authenticated && this.isStreamline) {
        this.router.navigate(['/funding-choices-streamline']);
      } else {
        this.router.navigate(['/funding-choices']);
      }
    }
  }
}
